import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import App from './main/App';
import store from './main/store';
import { NotificationsProvider } from './common/context/grimsbyNotifications';
import { GrimsbyNavProvider } from './common/context/grimsbyNavigation';
import GrimsbyGlobalErrorBoundary from './common/components/ErrorBoundary/GrimsbyGlobalErrorBoundary';
import { AuthenticationProvider } from './common/context/AuthenticationProvider';
import { AuthorizationProvider } from './common/context/AuthorizationProvider';
import { HelpPanelProvider } from './common/context/HelpPanelContext';

const rootElement = document.getElementById('root');
if (!rootElement) {
    throw new Error('Root element #root not found');
}

createRoot(rootElement).render(
    <Provider store={store}>
        <AuthenticationProvider>
            <AuthorizationProvider>
                <NotificationsProvider>
                    <GrimsbyNavProvider>
                        <GrimsbyGlobalErrorBoundary showFallback={true}>
                            <HelpPanelProvider>
                                <App />
                            </HelpPanelProvider>
                        </GrimsbyGlobalErrorBoundary>
                    </GrimsbyNavProvider>
                </NotificationsProvider>
            </AuthorizationProvider>
        </AuthenticationProvider>
    </Provider>,
);
